module.exports = __webpack_public_path__ + "static/media/not-found-illustration.f588a4c7.png";